import { render, staticRenderFns } from "./ModalEditorDeNoticias.vue?vue&type=template&id=65bee246&scoped=true"
import script from "./ModalEditorDeNoticias.vue?vue&type=script&lang=js"
export * from "./ModalEditorDeNoticias.vue?vue&type=script&lang=js"
import style0 from "./ModalEditorDeNoticias.vue?vue&type=style&index=0&id=65bee246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bee246",
  null
  
)

export default component.exports